import { cardsData } from '@/mocks/comicData';

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-10 text-center">
          {cardsData.title}
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {cardsData.items.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors"
              data-product-shop
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-[10px] rounded bg-accent-500 text-background-50 font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <span className="text-[11px] text-white/90">{item.chapter}</span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-1 whitespace-nowrap overflow-hidden text-ellipsis">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}